import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Stack, useMediaQuery, Tabs, Tab, Alert, Typography } from '@mui/material';
import AuthWrapper1 from '../AuthWrapper1';
import AuthLogin from './auth-forms/AuthLogin';
import AuthRegister from './auth-forms/AuthRegister';
import Logo from 'ui-component/Logo';
import imgMain from 'assets/images/auth/auth-img.png';
import LocalizationSection from 'layout/MainLayout/Header/LocalizationSection';
import { Trans, useTranslation } from 'react-i18next';
import useAuth from 'hooks/useAuth';
const noticeLastDate = new Date('2025-07-08');
const Login = () => {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const [tabValue, setTabValue] = useState(0);
    const { t } = useTranslation();
    const { user, loadingCurrentUser } = useAuth();
    const todayDate = new Date();
    const onRegisterSuccess = () => {
        setTabValue(0);
    };

    if (loadingCurrentUser || user) {
        return null;
    }

    return (
        <AuthWrapper1>
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item md={6} xs={12} className="scrollable-grid" sx={styles.scrollableGridStyles}>
                    <Grid
                        container
                        sx={styles.innerGridStyles}
                        alignItems={matchDownSM ? 'center' : 'flex-start'}
                        justifyContent={matchDownSM ? 'center' : 'space-between'}
                    >
                        <Grid item sx={styles.logoWrapperMd}>
                            <Link to="/">
                                <Logo />
                            </Link>
                        </Grid>
                        <Grid item xs={12}>
                            {todayDate < noticeLastDate ? (
                                <Stack justifyContent="center" alignItems="center" spacing={5} m={4}>
                                    <Box pl={{ xs: 0, sm: 3 }}>
                                        <Alert severity={'info'} sx={{ color: theme.palette.text.primary }}>
                                            <Typography variant="body1">
                                                <Trans i18nKey={'auth.login.login_update_notice_message'}>
                                                    Heads-up: We've upgraded the trading dashboard as part of The Leap release. All
                                                    passwords were reset — use this
                                                    <Typography component={Link} to="/forgot" variant="body1" color="primary.main">
                                                        link
                                                    </Typography>
                                                    to set a new one if you can't find the temporary password email. Inactive accounts may
                                                    take a couple of weeks to reappear, but all past trade and account history will migrate
                                                    automatically over the coming weeks.
                                                </Trans>
                                            </Typography>
                                        </Alert>
                                    </Box>
                                </Stack>
                            ) : null}
                            <Stack justifyContent="center" alignItems="center" spacing={5} m={4}>
                                <Box component={Link} to="/" sx={styles.logoWrapperXs}>
                                    <Logo />
                                </Box>
                                <Grid
                                    container
                                    spacing={{ xs: 0, md: 3 }}
                                    justifyContent="center"
                                    sx={{
                                        maxWidth: '100%',
                                        width: '100%'
                                    }}
                                >
                                    <Grid item xs={12}>
                                        <Tabs
                                            value={tabValue}
                                            onChange={(e, val) => setTabValue(val)}
                                            variant="fullWidth"
                                            sx={styles.tabsStyles}
                                        >
                                            <Tab label={t('auth.login.sign_in')} sx={styles.tabStyles} />
                                            <Tab label={t('auth.login.register')} sx={styles.tabStyles} />
                                        </Tabs>
                                    </Grid>
                                    <Grid item xs={12} mt={3}>
                                        {tabValue === 0 ? <AuthLogin loginProp={2} /> : <AuthRegister onSuccess={onRegisterSuccess} />}
                                    </Grid>
                                </Grid>
                                <Box display={'flex'} justifyContent={'right'} width={'100%'}>
                                    <Box sx={{ display: 'block' }}>
                                        <LocalizationSection />
                                    </Box>
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} sx={styles.imageWrapper}>
                    <img alt="Auth method" src={imgMain} style={styles.image} />
                </Grid>
            </Grid>
        </AuthWrapper1>
    );
};

export default Login;

const styles = {
    tabStyles: {
        fontSize: '16px',
        minHeight: '0px',
        color: 'grey.900',
        '&.Mui-selected': {
            borderRadius: '8px',
            color: 'common.white',
            backgroundColor: 'primary.800'
        }
    },
    scrollableGridStyles: {
        minHeight: '100vh',
        overflowY: 'auto',
        maxHeight: '100vh',
        '&::-webkit-scrollbar': { display: 'none' },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none'
    },
    innerGridStyles: {
        minHeight: '100vh'
    },
    logoWrapperMd: {
        display: { xs: 'none', md: 'block' },
        m: 5
    },
    logoWrapperXs: {
        display: { xs: 'block', md: 'none' }
    },
    tabsStyles: {
        bgcolor: 'primary.light',
        borderRadius: '12px',
        padding: '4px',
        borderBottom: 'none',
        '& .MuiTabs-flexContainer': {
            borderBottom: 'none'
        },
        '& .MuiTabs-indicator': { display: 'none' }
    },
    imageWrapper: {
        display: { xs: 'none', md: 'block' },
        position: 'fixed',
        right: 0,
        height: '100vh',
        userSelect: 'none',
        '& > img': {
            objectFit: 'cover'
        }
    },
    image: {
        width: '100%',
        height: '100%'
    }
};
